import { displayableExtensions, getExtensions } from '../slices/extensions/selectors.js';

const appSlice = {
  /**
   *
   * @param {State} state
   * @return {AppState}
   */
  app(state) {
    return state.app;
  },
  isPaused(state) {
    return state.app.paused;
  },
  isSuspend(state) {
    return state.app.suspended;
  },
  extensions: displayableExtensions,
  fullExtensionsList: getExtensions,
};

export default appSlice;
